:host {
  display: block;
  --sportsline-circular-progress-color: var(--Brand-Primary, #004ace);
  --sportsline-circular-progress-size: var(--sportsline-circular-progress-size, 2.5);
}

@keyframes sportsline-circular-progress-rotate {
  100% {
    transform: rotate(360deg);
  }
}

.sportsline-circular-progress {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 1rem;
}

.sportsline-circular-progress--sm {
  --sportsline-circular-progress-size: 1.5rem;
}

.sportsline-circular-progress--md {
  --sportsline-circular-progress-size: 2.5rem;
}

.sportsline-circular-progress__spinner {
  width: var(--sportsline-circular-progress-size);
  height: var(--sportsline-circular-progress-size);
  color: var(--sportsline-circular-progress-color);
  position: relative;
  display: inline-block;
}

.sportsline-circular-progress__spinner circle {
  stroke: currentColor;
  stroke-dasharray: 125.664;
  stroke-dashoffset: 0px;
}

.sportsline-circular-progress__spinner > span {
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.sportsline-circular-progress__spinner > span:first-child circle {
  color: #eeeeee;
}

.sportsline-circular-progress__spinner > span:last-child {
  display: inline-block;
  animation: sportsline-circular-progress-rotate 1.4s linear infinite;
  color: #1976d2;
  animation-duration: 550ms;
  position: absolute;
  left: 0;
}

.sportsline-circular-progress__spinner > span:last-child circle {
  stroke: currentColor;
  stroke-linecap: round;
  stroke: currentColor;
  stroke-dasharray: 80px, 200px;
  stroke-dashoffset: 0;
}
